import { saleBillDeleteApi } from "../../api/saleBill/saleBillDeleteApi"

type PayloadShape = Parameters<typeof saleBillDeleteApi>[0]

export async function saleBillDeleteService(payload: PayloadShape, token: string) {
	return await saleBillDeleteApi(payload, token)
}
